import { withI18n } from 'react-i18next';

import CategoriesMobileSubmenu from './CategoriesMobileSubmenu';

export const pureComponent = CategoriesMobileSubmenu;
export default withI18n()(CategoriesMobileSubmenu);
